import { Check, Sparkles } from "lucide-react";
import { KNOWMO, IMAGES } from "../mock";

export default function KnowMo() {
  const moduleImages = [IMAGES.knowmoDash, IMAGES.knowmoInventory];
  return (
    <section id="knowmo" className="relative py-24 lg:py-32 overflow-hidden">
      <div className="absolute top-0 left-1/4 h-[400px] w-[400px] rounded-full bg-teal-500/8 blur-[130px]" />
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="max-w-3xl reveal">
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.22em] text-teal-300 uppercase">
            <Sparkles size={14} /> {KNOWMO.eyebrow}
          </span>
          <h2 className="font-display font-bold text-white text-3xl lg:text-5xl mt-4 leading-tight tracking-tight">
            {KNOWMO.title}
          </h2>
          <p className="mt-6 text-slate-300/85 leading-relaxed">{KNOWMO.intro}</p>
        </div>

        <div className="mt-16 space-y-16">
          {KNOWMO.modules.map((m, i) => (
            <div
              key={i}
              className={`reveal grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${
                i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
              }`}
            >
              <div>
                <span className="text-xs font-semibold tracking-[0.25em] text-teal-400">{m.tag}</span>
                <h3 className="font-display font-bold text-white text-2xl lg:text-3xl mt-3 leading-tight">
                  {m.title}
                </h3>
                <p className="mt-5 text-slate-400 leading-relaxed">{m.text}</p>
                <ul className="mt-6 space-y-3">
                  {m.points.map((pt, j) => (
                    <li key={j} className="flex items-center gap-3 text-slate-200">
                      <span className="flex h-6 w-6 items-center justify-center rounded-full bg-teal-500/15 text-teal-300">
                        <Check size={14} strokeWidth={3} />
                      </span>
                      <span className="text-[15px]">{pt}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="relative">
                <div className="relative rounded-2xl overflow-hidden border border-teal-500/15 glow-teal">
                  <div className="flex items-center gap-1.5 px-4 py-3 bg-[#061513] border-b border-teal-500/10">
                    <span className="h-2.5 w-2.5 rounded-full bg-red-400/70" />
                    <span className="h-2.5 w-2.5 rounded-full bg-yellow-400/70" />
                    <span className="h-2.5 w-2.5 rounded-full bg-green-400/70" />
                    <span className="ml-3 text-[11px] text-slate-500 font-medium">knowmo.app / {m.tag.toLowerCase().replace(" ", "-")}</span>
                  </div>
                  <img src={moduleImages[i]} alt={m.title} className="w-full h-[300px] object-cover" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-tr from-[#04100f]/40 via-transparent to-teal-500/5 pointer-events-none" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}